import s from './UserNav.module.scss';
import './UserNav.module.scss';
import { Dropdown, DropdownMenu, DropdownToggle } from '@components/common';
import styled from 'styled-components';
import userImage from 'images/users/defaultAvatar.jpg';
import { useEffect, useState } from 'react';
import { api } from 'helpers/auth-axios';
import { notificationTypes } from 'constants/notification';
import { INotification } from 'interfaces/notification.interface';
import { palette } from 'styled/common';
import DropDownList from '../DropDownList';
interface IProps {
    openNotification?: () => void;
    openAuth?: () => void;
    openNotificationPopup: boolean;
    openAuthPopup?: boolean;
    dropPosition?: string;
    userData?: any;
    setOpenAuthPopup?: any;
}

const UserNav = ({
    openAuth,
    openAuthPopup,
    openNotification,
    openNotificationPopup,
    userData,
    setOpenAuthPopup,
}: IProps) => {
    var _user: any = JSON.parse(localStorage.getItem('user') || '{}');
    var _url: any = JSON.parse(localStorage.getItem('url') || '{}');
    const [user, setUser] = useState<any>();
    const [notifications, setNotifications] = useState<INotification[]>([]);
    const [profileImage, setProfileImage] = useState<any>(null);
    useEffect(() => {
        _user?.user?.role !== 'ADMIN' &&
            _user?.user_login !== 'customer' &&
            api
                .get('/appointments/all/notifications', {
                    params: {
                        page: 0,
                        pageSize: 40,
                    },
                })
                .then((res: any) => {
                    setNotifications(res.data);
                });
        setUser(JSON.parse(localStorage.getItem('user') || '{}'));
    }, []);

    return (
        <Flex>
            {_user?.user?.role == 'ADMIN' || _user?.user_login == 'customer' ? (
                ''
            ) : (
                <Dropdown>
                    {/*
                    <DropdownToggle onClick={openNotification}>
                        <BellIcon className={`${s.actionBtn}`}>
                            <i className="far fa-bell-on"></i>
                        </BellIcon>
                    </DropdownToggle>
                    */}
                    {openNotificationPopup && (
                        <DropdownMenu className={s.notifications_menu} scrollable={false}>
                            <div className={s.notifications_header}>
                                <Heading>Activity</Heading>
                            </div>
                            <div className={s.notifications_body}>
                                {notifications.length ? (
                                    notifications.map((notification: any) => {
                                        // const notificationType = notificationTypes.find(
                                        //     type =>
                                        //         notification.type === type.type &&
                                        //         notification.event === type.event
                                        // );
                                        return (
                                            <List>
                                                <Avatar className={` ${s.notification_icon}`}>
                                                    {/* <i className={notificationType?.icon}></i> */}
                                                </Avatar>
                                                <div className={s.notification_details}>
                                                    {/* <span className={s.notification_title}>
                                                    {notification.content.title}{' '}
                                                </span> */}
                                                    {notification}
                                                </div>
                                            </List>
                                        );
                                    })
                                ) : (
                                    <Notification>No Notification</Notification>
                                )}
                            </div>
                        </DropdownMenu>
                    )}
                </Dropdown>
            )}
            <Profile>
                <ProfileIcon
                    src={`https://profile-images-exclusively-s3-prd.s3.amazonaws.com/${_user?.user?.photo}`}
                    alt=""
                />

                <FlexCol>
                    <Title>{_user?.user?.role == 'ADMIN' ? 'Admin' : _user?.user_login}</Title>
                    <Name>
                        {_user?.user_login == 'customer'
                            ? _user?.user?.firstname + ' ' + _user?.user?.lastname
                            : _user?.user?.name}
                    </Name>
                </FlexCol>
                <Icon>
                    <DropDownList
                        userData={_user}
                        url={_url}
                        onBack={val => setOpenAuthPopup(val)}
                        openAuth={openAuth}
                        openAuthPopup={openAuthPopup}
                        dropPosition="down"
                    />
                </Icon>
            </Profile>
        </Flex>
    );
};
const BellIcon = styled.div`
    color: rgba(38, 52, 70) !important;
    border-radius: 9999px !important;
    cursor: pointer;
`;
const Heading = styled.div`
    color: rgba(255, 255, 255) !important;
    font-weight: 500 !important;
    font-size: 1.25rem !important;
    line-height: 1.75rem !important;
`;
const Flex = styled.div`
    align-items: center !important;
    display: flex !important;
`;
const Profile = styled.div`
    align-items: center !important;
    display: flex !important;
    margin-left: 2rem;
    @media screen and (min-width: 200px) and (max-width: 375px) {
        margin-left: 0.5rem;
    }
    @media screen and (min-width: 376px) and (max-width: 398px) {
        margin-left: 1rem;
    }
`;
const List = styled.div`
    display: flex;
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
    border: 0.1rem solid ${palette.grey.lightest};
    align-items: center;
`;
const Avatar = styled.div`
    margin-right: 0.75rem !important;
`;
const ProfileIcon = styled.img`
    width: 36px;
    height: 36px;
    border-radius: 2rem !important;
    margin-right: 0.5rem !important;
`;
const FlexCol = styled.div`
    flex-direction: column !important;
    display: flex !important;
`;
const Title = styled.div`
    color: rgba(12, 83, 252) !important;
    font-size: 0.875rem !important;
    line-height: 1.25rem !important;
    text-align: left !important;
    text-transform: capitalize;
`;
const Name = styled.div`
    color: rgba(38, 52, 70) !important;
    font-weight: 500 !important;
    font-size: 0.9rem !important;
`;
const Icon = styled.div`
    color: rgba(188, 192, 197) !important;
    font-size: 0.875rem !important;
    line-height: 1.25rem !important;
    margin-left: 0.5rem !important;
    margin-top: 1.25rem !important;
    cursor: pointer;
`;
const Notification = styled.div`
    margin: 0.5rem !important;
`;
export default UserNav;
